import { createAsyncThunk } from "@reduxjs/toolkit";
import { USER_PASSWORD_CHANGE } from "../action-types";
import { showAlert } from "../slices/features/alert";
import { getBaseUrl } from "../selectors/features";
import { UserPasswordChangeService } from "@root/services/user-password-change";
import { TOAST_VARIANT } from "@root/constants/common";
import { t } from 'i18next';

const userPasswordChangeService = new UserPasswordChangeService();

interface UserPasswordChangePayload {
  payload: Record<string, string>;
  onSuccess: any;
  onError: any;
}

export const userPasswordChange = createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(
  USER_PASSWORD_CHANGE,
  async (requestPayload: UserPasswordChangePayload, thunkAPI) => {
    const baseUrl = getBaseUrl(thunkAPI.getState());
    const { payload } = requestPayload;
    const { data, error } = await userPasswordChangeService.userPasswordChange(
      baseUrl,
      payload
    );

    if (error) {
      thunkAPI.dispatch(
        showAlert({
          message:
            data?.message || data?.userMessage || data?.code || data || "",
          type: TOAST_VARIANT.ERROR,
        })
      );
      return thunkAPI.rejectWithValue(data);
    } else {
      thunkAPI.dispatch(
        showAlert({
          message: t('common:password.passwordUpdate'),
          type: TOAST_VARIANT.SUCCESS,
        })
      );
    }
    return thunkAPI.fulfillWithValue(data);
  }
);
